import * as React from "react";
import SectionHeading from "~/primitiveComponents/dataDisplay/Section/SectionHeading";
interface FormSectionHeadingProps {
    title: string | JSX.Element;
    description?: string | JSX.Element;
}
export default function FormSectionHeading(props: FormSectionHeadingProps) {
    return <SectionHeading title={props.title} description={props.description}/>;
}
